"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
class TherapyNote extends base_model_1.default {
    constructor(data = {
        id: null,
        datetime: null,
        behavior: null,
        mood: null,
        affect: null,
        speech: null,
        thought_process: null,
        cognition: null,
        insight: null,
        key_stressor_event: null,
        recovery_env_notes: null,
        sleeping_eating_notes: null,
        intervention: null,
        intervention_response: null,
        next_session_plan: null,
        care_necessity: null,
        additional_notes: null,
        user_session: null,
    }) {
        super(data);
        this.datetime = defaults_1.defaultDate(data.datetime);
        this.behavior = defaults_1.defaultString(data.behavior);
        this.mood = defaults_1.defaultString(data.mood);
        this.affect = defaults_1.defaultString(data.affect);
        this.speech = defaults_1.defaultString(data.speech);
        this.thought_process = defaults_1.defaultString(data.thought_process);
        this.cognition = defaults_1.defaultString(data.cognition);
        this.insight = defaults_1.defaultString(data.insight);
        this.key_stressor_event = defaults_1.defaultString(data.key_stressor_event);
        this.recovery_env_notes = defaults_1.defaultString(data.recovery_env_notes);
        this.sleeping_eating_notes = defaults_1.defaultString(data.sleeping_eating_notes);
        this.intervention = defaults_1.defaultString(data.intervention);
        this.intervention_response = defaults_1.defaultString(data.intervention_response);
        this.next_session_plan = defaults_1.defaultString(data.next_session_plan);
        this.care_necessity = defaults_1.defaultString(data.care_necessity);
        this.additional_notes = defaults_1.defaultString(data.additional_notes);
        this.user_session = defaults_1.defaultString(data.user_session);
    }
}
exports.default = TherapyNote;
defaults_1.assignGetSet(TherapyNote, { snake: 'thought_process', camel: 'thoughtProcess' });
defaults_1.assignGetSet(TherapyNote, { snake: 'key_stressor_event', camel: 'keyStressorEvent' });
defaults_1.assignGetSet(TherapyNote, { snake: 'recovery_env_notes', camel: 'recoveryEnvNotes' });
defaults_1.assignGetSet(TherapyNote, { snake: 'sleeping_eating_notes', camel: 'sleepingEatingNotes' });
defaults_1.assignGetSet(TherapyNote, { snake: 'intervention_response', camel: 'interventionResponse' });
defaults_1.assignGetSet(TherapyNote, { snake: 'next_session_plan', camel: 'nextSessionPlan' });
defaults_1.assignGetSet(TherapyNote, { snake: 'care_necessity', camel: 'careNecessity' });
defaults_1.assignGetSet(TherapyNote, { snake: 'additional_notes', camel: 'additionalNotes' });
defaults_1.assignGetSet(TherapyNote, { snake: 'user_session', camel: 'userSession' });
